import Image from "next/image";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "redux-share";
import { setIsAutoPlay } from "redux-share/slices/controllerSlice";
import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { setRecommendListPopover } from "redux-share/slices/popoversSlice";
import IMAGES from "../../../../../images/importImages";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const ControllbarTooltip = dynamic(() => import("../../mainComponent/footer/controllbar/controllbarTooltip"));

const AutoPlayToggle = () => {
    const { isAutoPlay } = useAppSelector(({ controller: { isAutoPlay } }) => ({ isAutoPlay }), shallowEqual);

    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    const dispatch = useAppDispatch();

    const handleSwitchAutoPlay = () => {
        dispatch(setIsAutoPlay(!isAutoPlay));
        localStorage.setItem("isAutoPlay", `${conditions(ConditionName.isAutoPlay)}`);
        if (conditions(ConditionName.isTouchScreenLandscape) && !conditions(ConditionName.isAutoPlay)) dispatch(setRecommendListPopover(true));
    };

    return (
        <div className="pl-relative">
            <div
                className={`pl-relative pl-flex pl-items-center pl-h-[14px] pl-w-[24px] pl-cursor-pointer pl-rounded-[15px] pl-transition-colors pl-duration-150 pl-ease-linear pl-border pl-border-white`}
                onClick={handleSwitchAutoPlay}
                onDoubleClick={(event: any) => event.stopPropagation()}
                onMouseOver={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(true)}
                onMouseLeave={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(false)}
            >
                <div
                    className={`pl-absolute pl-bottom-[-3px] pl-w-[18px] pl-h-[18px] pl-rounded-full pl-bg-white pl-transition-transform pl-duration-150 pl-ease-linear ${
                        conditions(ConditionName.isAutoPlay) ? "pl-translate-x-[10px]" : "pl-translate-x-[-15px]"
                    }`}
                >
                    <div className="pl-w-full pl-h-full pl-flex pl-items-center pl-justify-center pl-gap-0.5">
                        {conditions(ConditionName.isAutoPlay) ? (
                            <Image src={IMAGES.play} width={8} height={8} />
                        ) : (
                            <>
                                <span className="pl-inline-block pl-w-[3px] pl-h-[7px] pl-bg-secondary-600" />
                                <span className="pl-inline-block pl-w-[3px] pl-h-[7px] pl-bg-secondary-600" />
                            </>
                        )}
                    </div>
                </div>
            </div>
            {showTooltip && (
                <ControllbarTooltip
                    title={`پخش خودکار ${conditions(ConditionName.isAutoPlay) ? "روشن" : "خاموش"} است`}
                    className="!pl-bottom-[346%] !pl-right-[-48px]"
                />
            )}
        </div>
    );
};

export default AutoPlayToggle;
